module.exports = __webpack_public_path__ + "img/r2.f995872c.png";